// Master state handler for WF1999 Classified Archive
const MASTER_STATE_KEY = "kAppState"
const MASTER_STATE_DEFAULT = {
    recycleRestored: false,
    decryptDownloaded: false,
    decryptStep: 0,
    oublietteDecrypted: false,
    oublietteUnpacked: false,
    email1Read: false,
    emailReplyReceived: false,
    emailReplyRead: false,
    emailAttachmentDownloaded: false,
    aRepaired: false,
    bRepaired: false,
    cRepaired: false,
    dRepaired: false,
    llamaUnlocked: false,
    numbersUnlocked: false,
    lureUnlocked: false,
    lureKey: null,
    cheatUnlocked: false,
    cheatKey: null,
    paperUnlocked: false,
    paperKey: null,
    speakRevealed: false,
    speakUnlocked: false,
    speakKey: null,
    biteRevealed: false,
    biteUnlocked: false,
    biteKey: null,
    contactRevealed: false,
    contactUnlocked: false,
    contactKey: null,
    activeWallpaper: 0,
    activeScreensaver: 0,
    volume: 0.5,
}
const syncHandlers = [];
export let masterState = JSON.parse(JSON.stringify(MASTER_STATE_DEFAULT));

export function getAppState() {
    return masterState;
}
export function restoreAppState() {
    masterState = JSON.parse(JSON.stringify(MASTER_STATE_DEFAULT));
    saveAppState();
}
export function loadAppState() {
    masterState = {
        ...masterState,
        ...JSON.parse(localStorage.getItem(MASTER_STATE_KEY))
    };
    syncAppState();
}
export function saveAppState() {
    localStorage.setItem(MASTER_STATE_KEY, JSON.stringify(masterState));
}

export function addSyncHandler(callback) {
    if (callback) syncHandlers.push(callback);
}
export function syncAppState() {
    for (const handler of syncHandlers) {
        try {
            handler(masterState);
        } catch (e) {
            console.error('Error encountered trying to run master sync: ' + e);
        }
    }
}
